import './btn_set_basic.less';

import React, { Children, cloneElement } from 'react';
import classNames from 'classnames';

import compact from 'lodash/compact';

const ButtonSet = ({ className, children })=> {

  var i = 0;

  return (
    <span className={classNames('btn-set-basic', className)}>
      { 
        Children.map(compact(children), (child)=> {
          var newClass;
          if (i === 0) {
            newClass = 'leftmost';
          } else if (i === Children.count(children) - 1) {
            newClass = 'rightmost';
          } else {
            newClass = 'middle';
          }

          const newChild = (
            cloneElement(child, { 
              ...child.props, className: classNames(child.props.className, newClass) 
            })
          );
          i+=1;
          return newChild;
        })
      }
    </span>
  );
};


export const ButtonSetByType = ({ className, ...props })=>
  <span {...props} className={classNames('btn-set-basic-by-type', className)} />;

export default ButtonSet;
